<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100 d-none d-lg-block"
        src="../assets/imgs/arreglalo/landings/errores/banner_hero.jpg"
        alt="Arréglalo"
      />

      <img
        class="w-100 d-block d-lg-none"
        src="../assets/imgs/arreglalo/landings/errores/banner_hero_mobile.jpg"
        alt="Arréglalo"
      />

      <div class="textobanner">
        <div class="container-fluid">
          <div class="row pt-lg-5">
            <div class="col-lg-6 centrarlg">
              <div>
                <h1 class="rojo bold fXG">
                  <em>
                    BIENVENIDO A TU VIAJE HACIA EL ÉXITO EMPRENDEDOR EN EL 2024.
                  </em>
                </h1>
                <p class="azuloscuro fG2 bold">
                  Descarga nuestro eBook exclusivo y evita los 5 errores más
                  comunes al iniciar tu propio negocio.
                </p>
                <p class="pb-5 py-lg-5">
                  <span
                    @click="toggleOverlay()"
                    class="pointer btnaction fG bold"
                    >DESCARGA GRATIS</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="explora" class="py-0 py-lg-5">
      <div class="row py-0 py-lg-5 d-flex align-items-center">
        <div class="col-lg-4">
          <img
            class="w-100"
            src="../assets/imgs/arreglalo/landings/errores/libros.jpg"
            alt="Arréglalo"
          />
        </div>
        <div class="col-10 offset-1 col-lg-7 offset-lg-0 pb-5 pb-lg-0">
          <h2 class="rojo fXG pb-4 bold">
            Explora temas clave que cubre nuestro eBook exclusivo:
          </h2>
          <div class="borderleftazul mb-4">
            <p class="azuloscuro fG2 bold">Capítulo 1:</p>
            <p class="grisoscuro fG">
              Rompiendo el Miedo al Fracaso <br />
              Estrategias para superar el miedo y enfrentar los desafíos con
              confianza
            </p>
          </div>
          <div class="borderleftazul mb-4">
            <p class="azuloscuro fG2 bold">Capítulo 2:</p>
            <p class="grisoscuro fG">
              Financiamiento Inteligente <br />
              Consejos prácticos para asegurar la financiación necesaria para tu
              emprendimiento
            </p>
          </div>
          <div class="borderleftazul mb-4">
            <p class="azuloscuro fG2 bold">Capítulo 3:</p>
            <p class="grisoscuro fG">
              Planificación Estratégica <br />
              Cómo elaborar un plan de negocios efectivo y sostenible
            </p>
          </div>
          <div class="borderleftazul mb-4">
            <p class="azuloscuro fG2 bold">Capítulo 4:</p>
            <p class="grisoscuro fG">
              Construyendo una Mentalidad Emprendedora <br />
              Claves para desarrollar una mentailidad fuerte y resiliente
            </p>
          </div>
          <div class="borderleftazul mb-4">
            <p class="azuloscuro fG2 bold">Capítulo 5:</p>
            <p class="grisoscuro fG">
              Conectando con tu Audiencia <br />
              Estrategias de marketing efectivas para construir una base de
              clientes sólida
            </p>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container-fluid">
        <div class="row py-5">
          <div class="col-12 py-5 text-center">
            <h2 class="fXG azuloscuro bold">Testimonios de Éxito</h2>
            <p class="grisoscuro fG2 bold px-5">
              Descubre cómo otros emprendedores aplicaron las lecciones del eBook para alacanzar el éxito en sus negocios.
            </p>
          </div>
          <div class="col-12 pt-4">
            <div class="row">
              <div class="col-lg-4 text-center pb-5">
                <p>
                  <img src="../assets/imgs/arreglalo/landings/errores/pilar-lopez.jpg" alt="Testimonio">
                </p>
                <p class="fM grisoscuro">
                  "Adquirir una franquicia de Arréglalo fue la mejor decisión para mi emprendimiento. El costo de producción bajo maximizó mis márgenes de ganancia, recuperando mi inversión rápidamente..."
                </p>
                <p class="fM grisoscuro">
                  -Pilar López
                </p>
              </div>
              <div class="col-lg-4 text-center pb-5">
                <p>
                  <img src="../assets/imgs/arreglalo/landings/errores/elmer-garcia.jpg" alt="Testimonio">
                </p>
                <p class="fM grisoscuro">
                  "Nos sentimos respaldados en cada paso, desde la apertura hasta el crecimiento continuo. Las mentorías y capacitaciones prepararon a nuestro equipo para ofrecer un servicio excepcional."
                </p>
                <p class="fM grisoscuro">
                  -Elmer García
                </p>
              </div>
              <div class="col-lg-4 text-center pb-5">
                <p>
                  <img src="../assets/imgs/arreglalo/landings/errores/miguel-hernandez.jpg" alt="Testimonio">
                </p>
                <p class="fM grisoscuro">
                  "El apoyo experto del corporativo es invaluable. Cada vez que enfrentamos un desafío, contamos con asesoramiento en tiempo real y soluciones rápidas. "
                </p>
                <p class="fM grisoscuro">
                  -Miguel Hernández
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container-fluid">
        <div class="row pb-5">
          <div class="col-12 pb-5">
            <img class="w-100" src="../assets/imgs/arreglalo/landings/errores/comunidad.jpg" alt="Comunidad Arréglalo">
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>

    <div class="overlay" v-if="$store.state.overlay == true">
      <div class="overlaybg" @click="toggleOverlay()"></div>
      <div class="overlay-contenido">
        <div class="container">
          <div class="row">
            <div class="col-12 rounded shadow py-4 contbtn bgazul">
              <div class="btncerrar" @click="toggleOverlay()">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  />
                </svg>
              </div>

              <div class="row">
                <div class="col-12 text-center fG2 blanco bold pb-4">
                  Ingresa tu correo para bajar el eBook.
                </div>

                <div class="col-10 offset-1 blanco">
                  <form @submit="submitFormulario($event)">
                    <!-- <label>
                      <span>Tu nombre:</span>
                      <input
                        type="text"
                        v-model="signupForm.nombre"
                        placeholder="Tu nombre"
                        required
                      />
                    </label> -->
                    <label>
                      <span>Tu correo electrónico:</span>
                      <input
                        type="email"
                        v-model="signupForm.email"
                        placeholder="Tu correo electrónico"
                        required
                      />
                    </label>

                    <div class="py-4 text-center m-auto recaptcha">
                        <vue-recaptcha
                        ref="recaptcha"
                        sitekey="6LejQsYqAAAAANshgulDv3M6YKEShJc7LQzAV-wj"
                        @verify="onVerify"
                        @expired="onExpired"
                      ></vue-recaptcha> 
                      </div>
                    <!-- <label>
                      <span>Tu teléfono:</span>
                      <input
                        type="tel"
                        pattern="[0-9]{10}"
                        title="Introduce un teléfono válido."
                        v-model="signupForm.telefono"
                        placeholder="Tu teléfono"
                        required
                      />
                    </label> -->

                    <label class="text-center">
                      <button type="submit" class="btnblanco d-inline-block">
                        ENVIAR
                      </button>
                    </label>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavLanding";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/FooterLanding";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    Footer,
    SiteNav,
    VueRecaptcha
  },
  data() {
    return {
      recaptchaResponse: "",
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        email: "",
        telefono: "",
        landing: "Los 5 errores del emprendedor",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
    };
  },
  name: 'Los 5 Errores del Emprendedor',
  metaInfo: {
    title: 'Los 5 Errores del Emprendedor | Arréglalo', // Sets the page title
    meta: [
      {
        name: 'description',
        content: 'Bienvenido a tu viaje hacia el éxito emprendedor en el 2025.',
      },
    ],
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    onVerify(response) {
      // Captures the reCAPTCHA response token
      this.recaptchaResponse = response;
      console.log("reCAPTCHA verified:", response);
    },
    onExpired() {
      // Handle reCAPTCHA expiration
      this.recaptchaResponse = "";
      console.log("reCAPTCHA expired.");
    },
    submitFormRecaptcha() {
      if (!this.recaptchaResponse) {
        alert("Please complete the reCAPTCHA.");
        return;
      }
      // Send the reCAPTCHA response to your backend for verification
      console.log("Submit form with reCAPTCHA:", this.recaptchaResponse);
    },
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    submitFormulario(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      let qData = this.signupForm;
      qData.recaptcha_response = this.recaptchaResponse;

      this.$http
        .post(
          "https://arreglalo.com.mx/inbound/api/registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.toggleOverlay();

              //fbq('trackCustom', 'LeadConversion', {formulario: '5-errores-del-emprendedor', email: this.signupForm.email});


              this.signupForm = {
                nombre: "",
                email: "",
                telefono: "",
                landing: "Los 5 errores del emprendedor",
              };

             
              swal.fire("Bien", res.msg, "success");

              window.open(
                "https://www.arreglalo.com.mx/ARRE_ebook_5errores.pdf",
                "_blank"
              );
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({ click: this.$store.state.overlay });
    },
  },
};
</script>
